<template>
  <div>
    <div class="color-line"></div>
    <div class="error-container">
      <i class="pe-7s-way text-info big-icon"></i>
      <h1>404</h1>
      <strong>Page Not Found</strong>
      <p>
        Sorry, but the page you are looking for has note been found. Try checking the URL for error, then hit the refresh button on your browser or try found something else in our app.

      </p>
      <a role="button" @click="$router.go(-1)"><button class="btn btn-xs btn-info">Go back</button></a>
    </div>
  </div>

</template>

<style>
</style>
<script>

export default {
  components: {},
  name: 'Error404',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }

}
</script>



// WEBPACK FOOTER //
// src/components/error/Error404.vue